/** Mensagens e helpers anti-enumeração de email (OWASP). */

export const AUTH_SIGNUP_EMAIL_UNAVAILABLE_TITLE =
  "Não foi possível concluir o cadastro";

export const AUTH_SIGNUP_EMAIL_UNAVAILABLE_DESCRIPTION =
  "Não foi possível concluir o cadastro com este email. Verifique o endereço ou tente fazer login.";

export const AUTH_PASSWORD_RESET_SENT_DESCRIPTION =
  "Se existir uma conta com este email, você receberá um link para redefinir sua senha.";

export const AUTH_RESEND_CONFIRMATION_SUCCESS =
  "Se houver uma conta pendente de confirmação, você receberá um novo email em breve.";

export const AUTH_EMAIL_CHANGE_PENDING_DESCRIPTION =
  "Se o endereço estiver disponível, você receberá um email de confirmação.";

const AUTH_GENERIC_ERROR = "Não foi possível concluir a operação. Tente novamente.";

const ENUMERATION_PATTERNS = [
  "user already registered",
  "already registered",
  "already been registered",
  "email address is already",
  "user with this email",
  "email already in use",
  "email_exists",
  "user not found",
  "no user found",
  "signup is disabled",
];

export function isEmailEnumerationRisk(message: string): boolean {
  const lower = message.toLowerCase();
  return ENUMERATION_PATTERNS.some((pattern) => lower.includes(pattern));
}

/** Supabase pode retornar usuário sem identities quando o email já existe (proteção nativa). */
export function isObfuscatedExistingSignupUser(data: {
  user?: { identities?: unknown[] } | null;
} | null | undefined): boolean {
  const identities = data?.user?.identities;
  return !!data?.user && Array.isArray(identities) && identities.length === 0;
}

export function getAuthErrorMessage(error: unknown): string {
  const errorMessage = (error as { message?: string })?.message || "";

  if (isEmailEnumerationRisk(errorMessage)) {
    return AUTH_SIGNUP_EMAIL_UNAVAILABLE_DESCRIPTION;
  }
  if (errorMessage.includes("Invalid email")) {
    return "Por favor, insira um email válido.";
  }
  if (
    errorMessage.includes("Password should be at least 6 characters") ||
    errorMessage.includes("weak_password")
  ) {
    return "A senha deve ter no mínimo 6 caracteres.";
  }
  if (errorMessage.includes("Invalid login credentials")) {
    return "Email ou senha incorretos.";
  }
  if (errorMessage.includes("Email not confirmed")) {
    return "Por favor, verifique seu email antes de fazer login.";
  }
  if (errorMessage.toLowerCase().includes("rate limit") || errorMessage.includes("too many")) {
    return "Muitas tentativas. Aguarde alguns minutos e tente novamente.";
  }

  return AUTH_GENERIC_ERROR;
}

export function maskAuthSensitiveError<T extends { message?: string } | null>(
  error: T,
): T | null {
  if (!error?.message) return error;
  if (isEmailEnumerationRisk(error.message)) return null;
  return error;
}
